import React, { useState, useEffect } from 'react';
import './Alerts.css';
import useService from 'views/default/useService';
import { useGetAllCommonStudentInitialDataMutation } from 'slices/get/common';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { PageHeader, LoadingSpinner, NoDataFound } from './CommonComponents';
import './common-components.css';

const Alerts = () => {
  let location = useLocation();
  const { checkAccessTime, fetchAccessToken } = useService();
  const currentPath = location.pathname;

  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);
  const access_token = fetchAccessToken();
  const [getSchoolData] = useGetAllCommonStudentInitialDataMutation();

  useEffect(() => {
    const fetchAlerts = async () => {
      setLoading(true);
      try {
        const response = await getSchoolData({ ep: '/student/alerts', token: access_token });
        if (response && response?.data && response.data.status) {
          setAlerts(response.data.data);
        }
        checkAccessTime(response, currentPath);
      } catch (error) {
        console.error('Error fetching alerts:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAlerts();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      weekday: "short",
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  // Beautiful gradient colors for alert cards
  const alertGradients = [
    'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
    'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
    'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
    'linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)',
  ];

  // Show loading state
  if (loading) {
    return (
      <div className="alerts-page">
        <LoadingSpinner message="Loading alerts..." fullPage={true} />
      </div>
    );
  }

  return (
    <div className="alerts-page">
      {/* Beautiful Header with Back Button */}
      <PageHeader
        title="Alerts & Notifications"
        subtitle="Stay updated with important announcements"
        icon="bell"
        showBackButton={true}
        gradient="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
        count={alerts.length}
        countLabel="Alerts"
      />

      {/* Alerts Content */}
      {alerts.length > 0 ? (
        <div className="alerts-grid">
          {alerts.map((alert, index) => (
            <div
              key={alert.id}
              className="alert-card-beautiful"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div 
                className="alert-card-header"
                style={{ background: alertGradients[index % alertGradients.length] }}
              >
                <div className="alert-icon-wrapper">
                  <i className="bi bi-megaphone"></i>
                </div>
                <div className="alert-badge">
                  <i className="bi bi-bell-fill"></i>
                </div>
              </div>
              <div className="alert-card-body">
                <h4 className="alert-card-title">{alert.title}</h4>
                <p className="alert-card-message">{alert.alert}</p>
                <div className="alert-card-footer">
                  <div className="alert-date-item">
                    <i className="bi bi-calendar-event"></i>
                    <span>Start: {alert.start_date ? formatDate(alert.start_date) : "N/A"}</span>
                  </div>
                  <div className="alert-date-item">
                    <i className="bi bi-calendar-check"></i>
                    <span>End: {alert.end_date ? formatDate(alert.end_date) : "N/A"}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <NoDataFound
          title="No Alerts Available"
          message="You're all caught up! There are no alerts or notifications at the moment. Check back later for updates."
          icon="bell-slash"
          showBackButton={true}
        />
      )}
    </div>
  );
};

export default Alerts;
